export default {
  title: 'La importación está en curso... 🙂',
  description: 'Se enviarán notificaciones de Slack cuando finalice la importación.',
  buttons: {
    open_followers_list: 'Abrir lista de seguidores',
  },
};
